import React, { useState, useEffect } from 'react';

function ConfiguratorOption({ image,title,productCount, filterGuid, onSelect }) {

    return (
        <div className="icon-container" onClick={() => onSelect(filterGuid)} style={{ cursor: 'pointer' } }>
            <img style={{ width: '150px' }} src={image} />
            <div className="title">{title}</div>
            {
                productCount &&
                <div className="products-available">{productCount} Product(s) available</div>
            }
     
        </div>
    );
}

export default ConfiguratorOption;